// removed by extract-text-webpack-plugin
module.exports = {"input":"input-2FUK4","input-start":"input-start-3fTJh","input-end":"input-end-1IFwc","label":"label-RNGEk","label-search":"label-search-mnq4-","dash":"dash-dytcu","prefix":"prefix-3nb2U","prefix-search":"prefix-search-3zO2W"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/train-in-way-info/style.scss
 ** module id = 71
 ** module chunks = 0
 **/